import {Map} from "immutable";
import { createSelector } from "reselect";
import { activeAdjustedExperienceState } from "views/Experiences/selector";
import { enabledFeaturesState } from "views/Auth/Login/selector";

const experienceUsersLoadingState = (state, props) => {
  return state.experienceUsers.get("loading");
};
export const experienceUsersLoadingSelector = () =>
  createSelector([experienceUsersLoadingState], (loading) => loading);

export const publishAllExperienceUsersLoadingState = (state) =>
  state.experienceUsers.get("publishloading", false);

export const publishAllExperienceUsersLoadingSelector = () =>
  createSelector([publishAllExperienceUsersLoadingState], (publishloading) => publishloading);

  export const exportAllToExcelExperienceUsersLoadingState = (state) =>
  state.experienceUsers.get("exportloading", false);

export const exportAllToExcelExperienceUsersLoadingSelector = () =>
  createSelector([exportAllToExcelExperienceUsersLoadingState], (exportloading) => exportloading);

export const experienceUsersCountState = (state) =>
  state.experienceUsers.get("experience_users", []).length;

export const experienceUsersCountSelector = () =>
  createSelector([experienceUsersCountState], (experienceUsersCount) => experienceUsersCount);

export const experienceUsersState = (state) =>
  state.experienceUsers.get("experience_users", []);

export const experienceUsersSelector = () =>
  createSelector([experienceUsersState], (experienceUsers) => experienceUsers);

export const activeExperienceUserIdState = (state) =>
  state.experienceUsers.get("activeExperienceUserId", null);

export const activeExperienceUserIdSelector = () =>
  createSelector([activeExperienceUserIdState], (activeExperienceUserId) => activeExperienceUserId);

export const activeExperienceUserSelector = () =>
  createSelector([experienceUsersState, activeExperienceUserIdState], (experienceUsers, activeExperienceUserId) => {
    console.log("activeExperienceUserSelector ==>", experienceUsers, activeExperienceUserId)
    return experienceUsers.find((item) => item.id === parseInt(activeExperienceUserId)) || {}
  });

export const studentNameFormatState = (state) =>
  state.experienceUsers.get("studentNameFormat", "first_name");

export const studentNameFormatSelector = () =>
  createSelector([studentNameFormatState], (studentNameFormat) => studentNameFormat);

export const userResponseState = (state) =>
  state.userResponses.get("user_responses", []);

export const allUserResponsesSelector = () =>
  createSelector([userResponseState], (userResponses) => userResponses);

export const currentCriteriaIdState = (state) =>
  state.experienceUsers.get("currentCriteriaId", "");

export const currentCriteriaIdSelector = () =>
  createSelector([currentCriteriaIdState], (currentCriteriaId) => currentCriteriaId);

export const gradingModalVisibleState = (state) =>
  state.experienceUsers.get("gradingModalVisble", false);

export const gradingModalVisibleSelector = () =>
  createSelector([gradingModalVisibleState], (gradingModalVisible) => gradingModalVisible);

export const overallGradingFormVisibleState = (state) =>
  state.experienceUsers.get("overallGradingFormVisible", false);

export const overallGradingFormVisibleSelector = () =>
  createSelector([overallGradingFormVisibleState], (overallGradingFormVisible) => overallGradingFormVisible);

export const showConvertedAchievementLevelState = (state, props) => {
  let showConvertedAchievementLevel = false
  const activeExperience = activeAdjustedExperienceState(state)
  console.log("activeExperienceGradingDisabledState", activeExperience)
  if (activeExperience && activeExperience.rubric && activeExperience.rubric.type_c === "criteria_with_points"){
    showConvertedAchievementLevel = true
  }
  return showConvertedAchievementLevel
}

export const showConvertedAchievementLevelSelector = () =>
  createSelector([showConvertedAchievementLevelState], (showConvertedAchievementLevel) => showConvertedAchievementLevel);